(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["NEXUS-FAETURED-PRODUCT"] && !Shopify.designMode) return;
  try {
    
(function () {
  function splitWords(el) {
    Array.from(el.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var f = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(function (w) {
          if (!w) return;
          if (!w.trim()) return f.append(w);
          var o = document.createElement('span');
          o.className = 'fpn-w';
          var i = document.createElement('span');
          i.textContent = w;
          o.appendChild(i);
          f.append(o);
        });
        n.replaceWith(f);
      } else if (n.nodeName === 'EM') {
        splitWords(n);
        n.style.display = 'inline';
      }
    });
  }

  function countUp(el) {
    var final = el.textContent, m = final.match(/\d+(?:[.,]\d+)?/g);
    if (!m || m.length !== 1 || /\d[.,]\d{3}(?!\d)/.test(m[0])) return;
    var token = m[0], sep = /[.,]/.exec(token), dec = sep ? token.length - sep.index - 1 : 0;
    var val = parseFloat(token.replace(',', '.')), t0 = performance.now() + 950;
    (function step(t) {
      var k = Math.min(1, (t - t0) / 1200);
      if (k > 0) {
        var v = (val * (1 - Math.pow(1 - k, 3))).toFixed(dec);
        if (sep) v = v.replace('.', sep[0]);
        el.textContent = final.replace(token, v);
      }
      if (k < 1) requestAnimationFrame(step); else el.textContent = final;
    })(performance.now());
  }

  function init(root) {
    if (root.dataset.fpnReady) return;
    root.dataset.fpnReady = '1';
    root.classList.add('fpn-js');
    var title = root.querySelector('[data-fpn-title]');
    if (title) {
      try {
        splitWords(title);
        title.querySelectorAll('.fpn-w span').forEach(function (e, i) { e.style.transitionDelay = (0.35 + i * 0.11) + 's'; });
      } catch (err) { /* title animation is optional */ }
    }
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var now = root.querySelector('[data-fpn-now]');
    function reveal() { root.classList.add('fpn-in'); if (now && !reduce) countUp(now); }
    if (reduce || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) reveal();
    else new IntersectionObserver(function (e, o) { if (e[0].isIntersecting) { o.disconnect(); reveal(); } }, { threshold: 0.1 }).observe(root);
    setTimeout(reveal, 4000); /* safety net: never leave the card covered */

    /* 3D tilt */
    var stage = root.querySelector('[data-fpn-stage]'), card = root.querySelector('[data-fpn-card]');
    if (stage && card && !reduce) {
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'rotateY(' + x * 8 + 'deg) rotateX(' + -y * 8 + 'deg)';
      });
      stage.addEventListener('mouseleave', function () { card.style.transform = ''; });
    }

    var form = root.querySelector('[data-fpn-form]');
    if (!form) return;
    var qty = form.querySelector('[data-fpn-qty]'), cta = form.querySelector('[data-fpn-cta]'),
        label = form.querySelector('[data-fpn-label]'), msg = form.querySelector('[data-fpn-msg]'),
        sel = form.querySelector('select[data-fpn-select]');

    function setQty(v) {
      qty.value = Math.max(1, parseInt(v, 10) || 1);
      qty.classList.remove('fpn-bump'); void qty.offsetWidth; qty.classList.add('fpn-bump');
    }
    form.querySelector('[data-fpn-plus]').addEventListener('click', function () { setQty(+qty.value + 1); });
    form.querySelector('[data-fpn-minus]').addEventListener('click', function () { setQty(+qty.value - 1); });
    qty.addEventListener('change', function () { setQty(qty.value); });

    /* Variant change: update price + availability */
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex], was = root.querySelector('[data-fpn-was]'), save = root.querySelector('[data-fpn-save]');
      now.textContent = o.dataset.price;
      var has = !!o.dataset.compare;
      was.hidden = !has; save.hidden = !has;
      if (has) { was.textContent = o.dataset.compare; save.textContent = 'Save ' + o.dataset.save + '%'; }
      var ok = o.dataset.available === 'true';
      cta.disabled = !ok;
      label.textContent = ok ? cta.dataset.label : cta.dataset.soldout;
    });

    /* Magnetic label + ripple */
    if (!reduce) {
      cta.addEventListener('mousemove', function (e) {
        var r = cta.getBoundingClientRect();
        label.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * 0.08 + 'px,' + (e.clientY - r.top - r.height / 2) * 0.15 + 'px)';
      });
      cta.addEventListener('mouseleave', function () { label.style.transform = ''; });
    }

    /* AJAX add to cart */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (cta.disabled) return;
      var r = cta.getBoundingClientRect(), d = document.createElement('i'), z = Math.max(r.width, r.height) * 2;
      d.className = 'fpn-rp';
      d.style.cssText = 'width:' + z + 'px;height:' + z + 'px;left:' + (r.width / 2 - z / 2) + 'px;top:' + (r.height / 2 - z / 2) + 'px';
      cta.appendChild(d); setTimeout(function () { d.remove(); }, 700);
      cta.disabled = true; msg.textContent = '';
      fetch(new URL(form.action).pathname + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
        .then(function (item) {
          label.textContent = cta.dataset.added;
          document.dispatchEvent(new CustomEvent('nexus:cart-added', { detail: item }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () { label.textContent = cta.dataset.label; cta.disabled = false; }, 1900);
        })
        .catch(function (err) {
          msg.textContent = (err && (err.description || err.message)) || 'Could not add to cart.';
          cta.disabled = false;
        });
    });
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-fpn-feat]').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
